import http from "@/services/http";
import {
  COMPARISON_STATISTICS_URL,
  PUBLIC_COUNTRIES_ORIGIN,
  PUBLIC_QUALIFICATION_LIST,
  STATISTICS_URL
} from "@/services/endpoints";

export function getStatistics(params) {
  return http.request({
    url: COMPARISON_STATISTICS_URL,
    method: 'get',
    params
  })
}
export function getDatabaseOfQualification(params) {
  return http.request({
    url: STATISTICS_URL,
    method: 'get',
    params
  })
}
export function getCountryList(params) {
  return http.request({
    url: PUBLIC_COUNTRIES_ORIGIN,
    method: 'get',
    params
  })
}
export function getQualificationList(params) {
  return http.request({
    url: PUBLIC_QUALIFICATION_LIST,
    method: 'get',
    params
  })
}

